<template>
    <c-dialog ref="dialog" mode="slide" width="85vw" enable-flex @resolve="editHandle">
        <!--同售账户-提现账户（卡号）信息及提现总金额-->
        <div v-if="accountType == 2" class="audit-account flex-center">
            <div class="audit-account-info">
                <span class="saas">{{accountInfo.saas_name || '-'}}</span>
                <span class="bank">{{accountInfo.bank_name || '-'}}（{{accountInfo.bank_card_no || '-'}}）</span>
            </div>
            <div class="audit-account-amount">提现金额：<em>￥{{accountInfo.totalAmount}}</em></div>
        </div>
		<c-form ref="form" vertical unit-width="100%">
            <c-form-item label="审批意见" required>
                <c-radio-group name="withdraw_status" :options="withdrawStatusDic" v-model="withdrawStatus"></c-radio-group>
            </c-form-item>
            <c-form-item label="打款方式" v-if="accountType == 1 && withdrawStatus == 3" required tip="选择原路退还则资金将退还客户原支付账户">
                <c-radio-group name="withdraw_pay_type" :options="payTypeOptions" v-model="withdrawPayType"></c-radio-group>
            </c-form-item>
            <c-form-item label="上传打款凭证" v-if="withdrawStatus == 3" :required="accountType == 2 || withdrawPayType == 0">
                <c-upload-file filePath="quote" name="pay_voucher_img_url" type="image"></c-upload-file>
            </c-form-item>
			<c-form-item label="备注" :required="withdrawStatus == 6">
                <c-input type="textarea" name="reject_reason" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
        <!--同售账户-提现申请单关联的明细商品信息-->
        <template v-if="accountType == 2">
            <div class="audit-items-title">提现明细商品</div>
            <c-table ref="itemTable" :data="itemList" border :paging="false" height="240">
                <c-table-column name="order_no" label="订单号" width="150"></c-table-column>
                <c-table-column label="产品信息" width="200">
                    <template #default="{data}">{{getProductText(data)}}</template>
                </c-table-column>
                <c-table-column name="produce_unique_code" label="背贴码" width="125"></c-table-column>
                <c-table-column name="produce_imei" label="IMEI" width="135"></c-table-column>
                <c-table-column label="订单结算金额" width="105" align-center>
                    <template #default="{data}">￥{{data.check_product_money}}</template>
                </c-table-column>
                <c-table-column label="售后金额" width="90" align-center>
                    <template #default="{data}">
                        <span v-if="data.check_return_money > 0" style="color: #FF5555">￥{{data.check_return_money}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>
                <c-table-column label="实际结算金额" width="105" align-center>
                    <template #default="{data}">￥{{realSettleMoney(data)}}</template>
                </c-table-column>
                <c-table-column name="order_create_date" label="下单时间" width="150"></c-table-column>
            </c-table>
        </template>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'cashWithdrawAudit',

	components: {
	},

	data() {
		return {
            //审批结果
            withdrawStatusDic: [
                {name: '审批通过',value: 3,color: 'blue'},
                {name: '审批驳回',value: 6,color: 'red'},
            ],
            withdrawStatus:3,         //审批状态
            payTypeOptions: [
                {name: '原路退还',value: 2,color: 'red'},
                {name: '线下打款',value: 0,color: 'blue'},
            ],
            withdrawPayType:2,         //打款方式
            userType:1,               //提现用户类型 1=商户主账号  3=小黑会员
            withdrawApplyIds:[],       //提现申请ID集合
            accountType:1,            //提现账户类型 1=通联账户  2=三方同售账户
            accountInfo:{},           //提现账户信息（商户名称、银行、卡号、提现总金额）
            itemList:[]               //提现申请单关联的明细商品列表
		}
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
        open(user_type,ids,account) {
            this.userType = user_type;
            this.accountType = account && account.accountType ? account.accountType : 1;
            this.accountInfo = account || {};
            //同售账户提现打款方式只能是线下打款
            this.withdrawPayType = this.accountType == 2 ? 0 : 2;
            this.withdrawStatus = 3;
            this.itemList = [];
            this.$refs.form.clear();
            this.$refs.form.set({
                withdraw_status:this.withdrawStatus,
                withdraw_pay_type:this.withdrawPayType
            });
            this.withdrawApplyIds = ids||[];
            //同售账户-查询提现申请单关联的明细商品信息
            if (this.accountType == 2 && this.withdrawApplyIds.length){
                this.loadItemList();
            }
			//填充form表单
			this.$refs.dialog.open({
				title: '商户提现审批'
			});
        },

        /*********查询提现申请单关联的明细商品信息**********/
        loadItemList() {
            this.request({
                url: '/withdraw/apply/item/list',
                data: {
                    withdraw_apply_ids: this.withdrawApplyIds
                },
                success: data => {
                    this.itemList = data || [];
                }
            });
        },

        /*********实际结算金额=订单结算金额-售后金额**********/
        realSettleMoney(data) {
            return (parseFloat(data.check_product_money || 0) - parseFloat(data.check_return_money || 0));
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: 'withdraw/saas/audit',
				rule: {
                    withdraw_status: '请选择审批意见',
                    withdraw_pay_type: [{
                        type: 'empty',
                        message: '请选择打款方式',
                        skip: () => {
                            return this.accountType == 2 || this.withdrawStatus == 6;
                        }
                    }],
                    pay_voucher_img_url: [{
                        type: 'empty',
                        message: '请上传打款凭证',
                        skip: () => {
                            return (this.accountType == 1 && this.withdrawPayType == 2) || this.withdrawStatus == 6;
                        }
                    }],
                    reject_reason: [{
                        type: 'empty',
                        message: '审批驳回时必须输入备注',
                        skip: () => {
                            return this.withdrawStatus == 3;
                        }
                    }]
				},
				dataFormatter: data => {
                    data.withdraw_apply_ids = this.withdrawApplyIds;
                    //同售账户提现打款方式只能是线下打款
                    if (this.accountType == 2) {
                        data.withdraw_pay_type = 0;
                    }
                    return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: '提现审批成功',  // 提示内容,
                        type: 'success'
                    });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
.audit-account {
    box-sizing: border-box;
    height: 44px;
    border-radius: 4px;
    padding: 0 16px;
    margin-bottom: 14px;
    background: #EBF1FF;

    &-info {
        flex-grow: 1;
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 14px;
        color: #333;

        .saas {
            font-weight: bold;
        }

        .bank {
            color: #666;
        }
    }

    &-amount {
        font-size: 14px;
        color: #333;

        em {
            font-style: normal;
            font-weight: bold;
            color: #FF3E3E;
        }
    }
}

.audit-items-title {
    margin: 6px 0 8px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
}
</style>
